import { EFFICIENCY_HEADERS } from 'utils/constants/admin';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

const EfficiencyTable = () => {
    const efficiencyData = useSelector((state) => state.efficiency.efficiencyData);
    const trl = useTrls();

    return (
        <Table fullWidth withStripes bordered>
            <TableHead>
                <TableRow>
                    {EFFICIENCY_HEADERS.map((header) => (
                        <TableHeadCell key={header}>{trl(`admin.efficiencyReport.header.${header}`)}</TableHeadCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.keys(efficiencyData).map((source) => {
                    const {
                        impressions,
                        clicks,
                        ctr,
                        vacancyViews,
                        vtcr,
                        newRegistrations,
                        anyResponseFromUsers,
                        responseOnClickmeVacancy,
                        cr,
                    } = efficiencyData[source];
                    return (
                        <TableRow key={source}>
                            <TableCell>{source}</TableCell>
                            <TableCell>{impressions}</TableCell>
                            <TableCell>{clicks}</TableCell>
                            <TableCell>{ctr}</TableCell>
                            <TableCell>{vacancyViews}</TableCell>
                            <TableCell>{vtcr}</TableCell>
                            <TableCell>{newRegistrations}</TableCell>
                            <TableCell>{anyResponseFromUsers}</TableCell>
                            <TableCell>{responseOnClickmeVacancy}</TableCell>
                            <TableCell>{cr}</TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default EfficiencyTable;
